import { DataTypes } from '@bimser/components/dist/BCExtremeGrid/entities';
import { ItemType } from '../../components/ExtremeGrid/entities';

export const getGridDataTypeOfFilterType = (type: ItemType): DataTypes => {
	switch (type) {
		case ItemType.Boolean:
			return 'boolean';
		case ItemType.DateTimeOffset:
			return 'datetimeOffset';
		case ItemType.DateTime:
			return 'datetime';
		case ItemType.Decimal:
		case ItemType.Double:
		case ItemType.Float:
		case ItemType.Int16:
		case ItemType.Int32:
		case ItemType.Int64:
			return 'number';
		case ItemType.MultiLanguage:
			return 'multiLanguage';
		case ItemType.DateRange:
			return 'dateRange';
		case ItemType.String:
		default:
			return 'string';
	}
};
